import { Box } from "@mui/material";
import { ConnectBusinessSkills } from "./connectBusinessSkills";

import { ConnectBusinessAvailability } from "./connectBusinessAvailability";
import { ConnectBusinessRequirementsBar } from "./ConnectBusinessRequirementsBar";

export const ConnectEmployeeLayout = () => {
  return (
    <Box width="95%" height="100%">
      <ConnectBusinessAvailability />

      <Box
        sx={{
          display: "flex",
          width: "100%",
          gap: 2,
          alignItems: "stretch",
          height: "90%",
        }}
      >
        <Box sx={{ flex: 1 }}>
          <ConnectBusinessRequirementsBar />
        </Box>

        <Box sx={{ flex: 1 }}>
          <ConnectBusinessSkills />
        </Box>
      </Box>
    </Box>
  );
};
